import TSAbstractEntity from './TSAbstractEntity';
import {TSBemerkungScope} from './enums/TSBemerkungScope';
import TSBenutzer from './TSBenutzer';
import {TSSchadenfallStatus} from './enums/TSSchadenfallStatus';

export default class TSAbstractBemerkungEntity extends TSAbstractEntity {

    private _bemerkung: string;

    // transient
    private _editMode: boolean = false;

    public get bemerkung(): string {
        return this._bemerkung;
    }

    public set bemerkung(value: string) {
        this._bemerkung = value;
    }

    getBesitzerName(): string {
        return ''
    }

    getBesitzer(): TSBenutzer | undefined {
        return undefined;
    }

    getPreStatus(): TSSchadenfallStatus | undefined {
        return undefined;
    }

    getPostStatus(): TSSchadenfallStatus | undefined {
        return undefined;
    }

    getBegruendung(): string | undefined {
        return undefined;
    }

    getBemerkungScope(): TSBemerkungScope {
        return TSBemerkungScope.SYSTEM
    }

    deserialize(restObject: any): TSAbstractBemerkungEntity {
        super.deserialize(restObject);
        this.bemerkung = restObject.bemerkung;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.bemerkung = this.bemerkung;
        return restObject;
    }

    public get editMode(): boolean {
        return this._editMode;
    }

    public set editMode(value: boolean) {
        this._editMode = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSAbstractBemerkungEntity.ts